export default Vue => {
  Vue.directive("imgerror", {
    inserted: function(el, binding, vnode, oldVnode) {
      el.addEventListener(
        "error",
        function(e) {
          console.log(e);
        },
        false
      );
      // let styleEl = getComputedStyle(el, null)
    }
  });

  var clTime;
  Vue.directive("dacusClick", {
    componentUpdated: function(el, binding, vnode, oldVnode) {
      /*el.disabled = true;
      console.log(el.disabled)
      clTime = setTimeout(() => {
          el.disabled = false;
          console.log(el.disabled)
        }, 1000);*/
    }
  });
};
